import { useTranslation } from "react-i18next";

import { StyledAppLoader } from "./AppLoader.styled";


export const AppLoader = () => {
  const { t } = useTranslation();

  return (
    <StyledAppLoader>
      <div className="loader-container">
        <div className="loader-text">{t("getting-ready")}</div>
        <div className="loader-bar">
          <div className="loader-progress"></div>
        </div>
      </div>
    </StyledAppLoader>
  );
};
